
// *************************************************************************
// Jednoduchý carousel, který pro svou funkci využívá CSS snapping
// V současné době (2Q.2020) není ještě v prohlížečích implementováno
// správné zachování pozice carouselu při změně rozlišení. Funguje pouze
// v Chrome 81. Postupně by se ale mělo dostávat i do novějších prohlížečů.
//
// Instance carouselu se ukládá k DOM elementu a pokud není požadován autoplay
// (v tuto chvíli neimplementováno), vzniká instance až při prvním kliknutí
// uživatele na nějaké z tlačítek pro navigaci carouselu. Přirozený pohyb
// carouselu je zajištěn přes CSS, tj. JavaScript není pro jeho funkci potřeba.
//
// Z principu implementace carousel nemá přirozenou možnost být "nekonečný".
// *************************************************************************

// Použití:
// data-carousel="vertical" pro vertikální carousel

// Markup:
// <div class="...">
//    <div class="..." data-slider="slides">
//        <div>...</div>
//        <div>...</div>
//        <div>...</div>
//        <div>...</div>
//    </div>
//    <div class="..." data-slider="prev">...</div>
//    <div class="..." data-slider="next">...</div>
// </div>


var defaultOptions = {
	duration: 300
};

// Úložiště pro objekty reprezentující modální okna.
var sliders = new WeakMap();


// *************************************************************************
// Třída carouselu
// Instance je uložena k DOM elementu
// *************************************************************************

export function Slider(wrapper) {
	this.wrapper = wrapper;
	this.scrollArea = wrapper.querySelector("[data-slider='slides']");
	this.options = defaultOptions;
	this.options = {
		duration: wrapper.getAttribute("data-slider-duration") || this.options.duration,
	};

	this.activeObserver = new MutationObserver(this.onActiveChanged.bind(this));
	this.activeObserver.observe(this.scrollArea, {
		attributes: true,
		attributeFilter: ["class"],
		childList: true,
		subtree: true,
		characterData: false
	});

	this.isObservingActive = true;
}
Slider.prototype = {
	constructor: Slider,

	//
	// Přejdi na předchozí slide
	//
	prev: function() {
		var current = this.current();
		var slides = this.slides();

		if (!slides.length) {
			return;
		}

		var prevIndex = Math.max((current.index || 0) - 1, 0);
		this.moveTo(prevIndex);
	},

	//
	// Posuň carousel na další snímek
	//
	next: function() {
		var current = this.current();
		var slides = this.slides();

		if (!slides.length) {
			return;
		}

		var nextIndex = Math.min((current.index || 0) + 1, slides.length - 1);
		this.moveTo(nextIndex);
	},

	//
	// Aktuální slide a jeho index
	//
	current: function() {
		var position = this._getPosition();
		var slides = this.slides();
		var currentSlide = null;
		var currentIndex = null;
		for (var i = 0; i < slides.length; ++i) {
			var slide = slides[i];

			if ((this.direction() == "horizontal" && slide.offsetLeft - 1 <= position) || (this.direction() == "vertical" && slide.offsetTop - 1 <= position)) {
				currentIndex = i;
				currentSlide = slide;
			}
			else {
				break;
			}
		}

		return {
			slide: currentSlide,
			index: currentIndex
		}
	},

	//
	// Seznam všech slidů
	//
	slides: function() {
		return this.scrollArea.children;
	},

	//
	// Přechod na konkrétní číslo slidu
	//
	moveTo: function(index) {
		var currentIndex = this.current().index;
		if (currentIndex == null || index != currentIndex) {
			var slide = this.slides()[index];
			var position = this.direction() == "horizontal" ? slide.offsetLeft : slide.offsetTop;
			this._animatedScroll(position);
		}
	},


	//
	// Pokud se stane, že někde z venku je slide označený jako aktivní, posuňme
	// slider tak, aby byl vidět.
	//
	onActiveChanged: function(mutationsList, observer) {
		if (!this.isObservingActive) {
			return;
		}

		var slide = this.scrollArea.querySelector(".slider-slide.active");
		if (slide) {
			var position = this.direction() == "horizontal" ? slide.offsetLeft : slide.offsetTop;
			this._animatedScroll(position);
		}
	},


	//
	// Aktuální orientace carouselu
	//
	direction: function() {
		return getComputedStyle(this.scrollArea).getPropertyValue("flex-direction") == "row" ? "horizontal" : "vertical";
	},


	//
	// Aktuální pozice carouselu
	//
	_getPosition: function() {
		if (this.direction() == "horizontal") {
			return this.scrollArea.scrollLeft;
		}
		else {
			return this.scrollArea.scrollTop;
		}
	},

	//
	// Animovaný přechod na novou pozici
	//
	_animatedScroll: function(position) {
		if (this.direction() == "horizontal") {
			this.scrollArea.scrollTo({ left: position, top: 0, behavior: "smooth" });
		}
		else {
			this.scrollArea.scrollTo({ left: 0, top: position, behavior: "smooth" });
		}
	}
};


// *************************************************************************
// Vytvoří a/nebo vrátí instanci carouselu, která přísluší k danému elementu
// *************************************************************************

Slider.get = function(element) {
	if (!sliders.has(element)) {
		sliders.set(element, new Slider(element));
	}

	return sliders.get(element);
}



// *************************************************************************
// Události
// *************************************************************************

//
// Kliknutí na tlačítko prev/next v carouselu
//
document.addEventListener("click", function(event) {
	var isPrev = event.target.closest("[data-slider='prev']");
	var isNext = event.target.closest("[data-slider='next']");

	if (!isPrev && !isNext) { return; }
	event.preventDefault();

	var slider = event.target.closest(".slider");

	if (isPrev) {
		Slider.get(slider).prev();
	}
	if (isNext) {
		Slider.get(slider).next();
	}
});
